import React, { FC } from 'react';

import { NativeResources } from '@ariksa/inventory-core';

import { EC2Vulnerability } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/Compute/VirtualMachine/Vulnerability';
import { ECRImages } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/ECR/Components/ECRImages';
import { ContainerVulnerability } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Vulnerability/ContainerVulnerability/ContainerVulnerability';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

export const VulnerabilityTab: FC = () => {
  const { resourceType } = useActiveResourceContext();

  const getVulnerability = (resourceType: NativeResources) => {
    switch (resourceType) {
      case NativeResources.Ec2Instance:
      case NativeResources.LambdaFunction:
      case NativeResources.Container:
      case NativeResources.AmazonMachineImage:
      case NativeResources.GcpComputeEngine:
      case NativeResources.GcpCloudFunctions:
      case NativeResources.GcpContainer:
      case NativeResources.AzureVirtualMachine:
      case NativeResources.AzureVirtualMachineScaleSetInstance:
      case NativeResources.AzureVirtualMachineScaleSets:
      case NativeResources.AzureFunctions:
      case NativeResources.AzureContainer:
        return <EC2Vulnerability />;
      case NativeResources.ElasticKubernetesService:
      case NativeResources.ElasticContainerService:
      case NativeResources.EcsCluster:
      case NativeResources.Gcpgke:
      case NativeResources.Aks:
        return <ContainerVulnerability vulnerability />;
      case NativeResources.ElasticContainerRegistry:
        return <ECRImages vulnerability />;
      default:
        return null;
    }
  };

  return <>{getVulnerability(resourceType)}</>;
};
